// https://stackoverflow.com/a/28191966
export const getKeyByValue = (object, value) =>
    Object.keys(object).find((key) => object[key] === value);
